require("core-js/modules/es6.regexp.split");

var makeString = require('./helper/makeString');

module.exports = function chars(str) {
  return makeString(str).split('');
};